import React from "react";
import "./All_Project_Card.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";

const All_Project_Card = ({ projectId,imgSrc, projectName, location, subText }) => {

  const navigate = useNavigate()  
  
  console.log("projectId",projectId)

  return (
    <div className="all_project_card" onClick={() => navigate(`/project-details/${projectId}`)}>
      <div className="img_main_holder">
        <div className="img_holder">
          <img src={imgSrc} className="inner_img" />
        </div>
        <div className="overlay"></div>
      </div>
      <div className="bottom_div">
        <p className="project_name">{projectName}</p>
        <p className="location">{location}</p>

        <div className="sub_text_div">
          <p className="subtext">
            {subText}
          </p>
          <div className="icon_holder">
            <FontAwesomeIcon icon={faAngleRight} className="right_icon" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default All_Project_Card;
